'use strict';
export function Info(url) {
  Object.defineProperties(this, {
    "authorities": {
      get: function() {return this._authorities;},
      set: function(values) {
        if(!values) {
          throw new TypeError('原作が指定されていません。');
        }
        this._authorities = values;
      },
      enumerable: true
    },
    "categories": {
      get: function() {return this._categories;},
      set: function(values) {
        if(!values) {
          throw new TypeError('商品カテゴリが指定されていません。');
        }
        this._categories = values;
      },
      enumerable: true
    },
    "url": {
      get: function() {return this._url;},
      set: function(url) {
        if(!url) {
          throw new TypeError('商品カテゴリの問い合わせ先が不明です。');
        }
        this._url = url;
      },
      enumerable: true
    }
  });
  this.url = url;
};
Info.prototype.init = function() {
  return this.request()
    .then(this.toJSON)
    .then(function(json) {
      this.categories = json.info.category;
      this.authrities = json.info.authority;
      return this;
    }.bind(this))
    .catch(function(e) {
      var error = Object.create(null);
      error.status = 453;
      error.statusText = 'FAILED';
      error.message = '関連商品の商品カテゴリー情報が、取得できませんでした。';
      error.reason = e.message;
      return Promise.reject(JSON.stringify(error));
    });
};
Info.prototype.toJSON = function(response) {
  return response.json();
};
Info.prototype.request = function(response) {
  return fetch(this.url, {mode: 'cors'});
};